(function () {
  'use strict';

  angular
    .module('app.account-home', [])

    .component('accountHome', {
      bindings: {
        device: '<'
      },
      /* @ngInject */
      templateUrl: ["AccountService", function (AccountService) {
        return AccountService.getLinks().AccountHome;
      }],
      /* @ngInject */
      controller: ["$scope", "$q", "AccountService", "AppService", "CdnService", function ($scope, $q, AccountService, AppService, CdnService) {
        var ctrl = this;

        AccountService.initAccount(ctrl);

        // common account end

        AppService.getParams()
          .then(function (data) {
            if (data.Visitor.IDPicture === 0) {
              ctrl.userPicture = '/img/user-' + (data.Visitor.Title.IDTitle === 'M.' ? 'man' : 'woman') + '.gif';
            } else {
              CdnService.get(data.Visitor.IDPicture, '60x60')
                .then(function (res) {
                  ctrl.userPicture = res;
                })
                .catch(function (err) {
                  console.error(err);
                });
            }
          })
          .catch(function (error) {
            console.error(error);
          });

        var loadOrders = function () {
          var deferred = $q.defer();
          AccountService.getOrders()
            .then(function (response) {
              var orders = _.filter(response.Orders, function (order) {
                return order.IDState !== 390;
              });
              deferred.resolve({ ordersCount: orders.length });
            })
            .catch(function (error) {
              console.error(error);
            });
          return deferred.promise;
        };

        var loadLoyalty = function () {
          var deferred = $q.defer();
          AppService.getParams()
            .then(function (response) {
              deferred.resolve({ visitor: response.Visitor });
            })
            .catch(function (error) {
              console.error(error);
            });
          return deferred.promise;
        };

        ctrl.$onInit = function () {
          $scope.device = ctrl.device;

          ctrl.loading = true;

          $q.all([loadOrders(), loadLoyalty()])
            .then(function (results) {
              ctrl.ordersCount = results[0].ordersCount;
              ctrl.Visitor = results[1].visitor;
              ctrl.loading = false;
            })
            .catch(function (error) {
              console.error(error);
            });
        };

      }],
      controllerAs: 'accountCtrl'
    });

})();
